/**
 * Application wide configuration
 */

const config = {
  baseURI:'https://shopify-clone-app.herokuapp.com/api/v1',
  // baseURI: 'http://localhost:5000/api/v1',
  payPal:'AUO1i-KYdvQyqPCewSkXfrhx0GFx9G_wDT_Gd_qldQyurm22Ks4Edazqo6PtwC1JGpAzqiW07vLC8Glc',
  esewaImageUrl: process.env.REACT_APP_ESEWA_IMAGE_URL,
  esewaPaymentUrl: process.env.REACT_APP_ESEWA_PAYMENT_URL,
  apiEndPoint: {
    product: {
      fetchProducts: '/product',
      fetchProduct: '/product/:id',
      fetchProductReviews: '/product/:id/reviews',
      createReview: '/product/:id/reviews',
      deleteProduct: '/product/:id',
      createProduct: '/product',
      updateProduct: '/product/:id',
    },
    user: {
      login: '/auth/login',
      create: '/auth/register',
      fetchUsers: '/user',
      verifyEmail: '/auth/verify-email',
      deleteUser: '/user/:id',
      updateUser: '/user/:id',
      fetchUser: '/user/:id',
      forgotPassword: '/auth/forgot-password',
      resetPassword: '/auth/reset-password',
    },
    order: {
      createOrder: '/order',
      order: '/order/:id',
      pay: '/order/:id/pay',
      deliverOrder: '/order/:id/deliver',
      userOrder: '/order/auth-orders',
      orders: '/order',
    },
  },
};

export default config;
